import React from 'react';
import './steps.css';

interface StepsProps {
  step: number;
}

export const Steps: React.FC<StepsProps> = ({ step }) => {
  const steps = [
    { number: 1, name: 'Select Practices' },
    { number: 2, name: 'Contact Info' },
    { number: 3, name: 'Carbon Estimate' }
  ];

  return (
    <div className="steps-wizard">
      <div className="steps-container">
        {steps.map((stepItem, index) => (
          <div key={stepItem.number} className="step-item">
            <div className="step-circle-container">
              <div 
                className={`step-circle ${step >= stepItem.number ? 'active' : ''}`}
              >
                {stepItem.number}
              </div>
              {index < steps.length - 1 && (
                <div 
                  className={`step-line ${step > stepItem.number ? 'active' : ''}`}
                />
              )}
            </div>
            <div className={`step-name ${step >= stepItem.number ? 'active' : ''}`}>
              {stepItem.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
